import script from "./ProjectEventDates.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectEventDates.vue?vue&type=script&setup=true&lang=js"

import "./ProjectEventDates.vue?vue&type=style&index=0&id=074e302a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074e302a"]])

export default __exports__